import { UserStatus } from '../types';

import { CurrentUserData } from '~/modules/settings/_state/userForm.state';
import { createQueryHook } from '~/shared/providers/api';

export interface UserQueryParams {
  userId: string;
}

export interface UserQueryResult {
  user: CurrentUserData | null;
}

export const useUserQuery = createQueryHook(
  'settings.teamPermissions.user',
  (params: UserQueryParams) => ({
    coreUsersByOrganization: {
      __args: {
        filter: {
          ids: [params.userId],
        },
        pagination: {
          limit: 1,
          offset: 0,
        },
      },
      entries: {
        id: true,
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        createdAt: true,
        status: true,
        facilities: {
          id: true,
          facilityName: true,
        },
      },
    },
  }),
  {
    select: (data): UserQueryResult => {
      const user = data?.coreUsersByOrganization?.entries?.[0];
      if (!user) return { user: null };

      return {
        user: {
          id: user.id,
          firstName: user.firstName ?? '',
          lastName: user.lastName ?? '',
          email: user.email ?? '',
          phone: user.phoneNumber ?? null,
          status: (user.status === 'ARCHIVED'
            ? 'archived'
            : 'active') as UserStatus,
          roles: [],
          roleIds: [],
          facilities:
            user.facilities
              ?.map((f: { facilityName?: string }) => f.facilityName)
              .filter((name): name is string => !!name) ?? [],
          facilityIds:
            user.facilities
              ?.map((f: { id?: string }) => f.id)
              .filter((id): id is string => !!id) ?? [],
          accessCode: '',
          createdAt: user.createdAt ?? '',
        },
      };
    },
  },
);
